<script>
import { defineComponent, ref } from 'vue';
import { useRouter,useRoute } from "vue-router";
//component
import MainPage from '../component/Layout/MainPage.vue'
import InfoForm from '../component/InfoForm/InfoForm.vue'
import Campaign from '../component/Campaign/Campaign.vue'
//model
import { AddCartModel } from '@/core/Cart/model/CartModel';
// //service
import Topup2c2pService from '../service/Topup2c2pService'
import BzbsAuth from "@/core/Account/service/BzbsAuth"
//feature
import { useLandingFlow } from '../feature/LandingFlowFeature'
import { useLocale } from '../feature/LocaleFeature';
import { useModal } from '../feature/ModalFeature';


export default defineComponent({
  components: {
      MainPage,
      InfoForm,
      Campaign
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { query,campaign,blobWebLanding } = useLandingFlow()
    const { lbl } = useLocale()
    const modal = useModal()
    const categoryConfig = ref(null)
    const formInfo = ref(null)
    let dashboardConfig = ref('shopcode_gamestore')



    const clickNext = async () => {
        formInfo.value.submitForm()

        let res = formInfo.value.submitForm()
        if (res) {
            let value = formInfo.value.getValue()
            modal.loadingModal.show()
            await addToCart(campaign.value.id, value)
            modal.loadingModal.hide()
            goShoppingCartProduct()
        }
    }

    const addToCart = (campaignId,value) => {
        return new Promise((resolve) => {
            var cartItem = new AddCartModel();
            cartItem.addItem(campaignId, 1)
            cartItem.setRemark(value)
            cartItem.setClearCart()
            var cartRemarks = cartItem.getRemarks();
            var list = cartItem.getList()
            Topup2c2pService.apiAddItemToCart(query.value.token, cartRemarks, query.value.appId, list, blobWebLanding.value, query.value.jwt).subscribe({
                next: (data) => {
                    console.log(data)
                    resolve();
                },
                error: (err) => {
                    console.log(err)
                    resolve();
                    // errorApi(err);
                },
            });
        });
    }

    const goShoppingCartProduct = async () => {
        // debugger
        let accessKey = await getShoppingCartAccessKey()
        if (accessKey == null) {
            return
        }
        let appName = query.value.appName
        let url = query.value.shoppingCartUrl+ `/landing/${appName}/shipping?access_key=${accessKey}&appname_config=${appName}`
        window.location.href = url
    }

    const getShoppingCartAccessKey = () => {
        return new Promise((resolve) => {
            let payload = {
                returnUrl: query.value.returnUrl,
                successUrl: query.value.returnUrl,
                errorUrl: query.value.returnUrl,
                appId: query.value.appId,
                appName: query.value.appName,
                cartType: 'C2PTopup',
                routeMode: 'push',
            }
            let jsonPayload = JSON.stringify(payload)
            BzbsAuth.apiCreateAccessKey(query.value.token, jsonPayload).subscribe({
                next: (data) => {
                    resolve(data.accessKey)
                },
                error: (err) => {
                    console.log(err)
                    resolve(null)
                    //errorApi(err)
                },
            })
        });
    }

    const onClickBack = () => {
      router.replace('/topup2c2p/list/' + route.params.categoryId)
    }

    const getPrice = () => {
        return campaign.value.pricePerUnit
    }

    const getPoint = () => {
        // TODO: show earn point
        return campaign.value
    }

    // init()
    // //initialCategory()
    return {
      categoryConfig,
      onClickBack,
      dashboardConfig,
      getPrice,
      getPoint,
      clickNext,
      formInfo,
      lbl
    }
  },
});
</script>
<template>
    <MainPage :title="lbl.detail.title" @clickBack="onClickBack()">
        <div class="pt-4 pb-8">
            <InfoForm ref="formInfo"></InfoForm>
            <div class="mt-4">
                <Campaign ></Campaign>
            </div>

            <div class="max-width-page fixed bottom-0 h-[425px] bg-white shadow w-full px-5 py-2.5">
                <div class="flex flex-auto justify-between items-center">
                    <div class="flex flex-col flex-auto text-14">
                        <div class="flex items-center pr-2.5 justify-between">
                            <div class="ml-0 mr-auto text-14 text-a-gray-4a4a4a">{{ lbl.detail.total }}</div>
                            <div class="text-14 text-a-orange-f9a601 pr-2">฿ {{FilterPriceFormat(getPrice())}}</div>
                        </div>
                    </div>
                    <div >
                        <button class="bg-a-orange-f9a601 text-white text-14 rounded-10 h-11 w-20" @click="clickNext()">{{ lbl.detail.next }}</button>
                    </div>
                </div>
            </div>
        </div>
    </MainPage>
</template>
<style lang="scss" scoped>
    @import '../style/base.scss';
    .max-width-page {
        max-width: $max-width-mobile;
    }
</style>
